import { CircularProgress } from "@mui/material";
import { DownloadGuide } from "@unisearch/common";
import {
  isCourseCompare,
  isCourseFavorite,
  isUniCompare,
  isUniFavorite,
  objectToQueryString,
  ucfirst,
  isEmpty,
} from "@unisearch/helpers";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { FaMapMarkerAlt, FaUniversity } from "react-icons/fa";
import { useRecoilValue } from "recoil";
import styles from "./uni_thumb_box_mobile.module.scss";
const FavoriteAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/favorite"),
  { ssr: false }
);

const CompareAction = dynamic(
  () => import("@unisearch/common/ui_element/actions/compare"),
  { ssr: false }
);

export const UniThumbBoxMobile = ({ item }) => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();

  const sliceItems = item && item.course.length > 0 && item.course.slice(0, 4);
  const [loader, setLoader] = useState([]);

  const MoreExam = ([...exams]) => {
    if (!exams || exams.length <= 1) return false;
    exams.shift();
    if (exams && exams.length > 0) {
      return (
        <div className={styles.examNumber}>
          <strong>+{exams.length}</strong>
          <ul className={`uni-tooltip ${styles.examlist}`}>
            {exams.map((ex, i) => {
              return (
                <li key={i}>
                  {ex.exam_examName} : {ex.course_score}{" "}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  };

  //return with search query
  const goSearchResult = async (returnPath, university) => {
    setLoader([university]);
    // await router.push({
    //   pathname: returnPath,
    //   query: router.query,
    // });
    window.open(
      `${returnPath}?${objectToQueryString({ ...router.query, page: 1 })}`,
      "_blank"
    );
    setLoader([]);
    return true;
  };

  return (
    <div className={styles.uni_search_box}>
      {/* Address */}
      <div className={styles.logo_uni_info_wrapper}>
        <Link
          legacyBehavior
          href={`/study/${item?.country?.slug}/university/${item?.slug}`}
        >
          <a className={styles.logo_wrapper} target="_blank">
            <img
              src={
                item?.logo?.src ||
                getAssets("assets/images/uni-profile/logo-placeholder.png")
              }
              alt={item?.logo?.alt}
            />
          </a>
        </Link>

        <div className={styles.uni_brief_wrapper}>
          <Link
            legacyBehavior
            href={`/study/${item?.country?.slug}/university/${item?.slug}`}
          >
            <a target="_blank">
              <h4 className={styles.uni_name}>{item?.universityName}</h4>
            </a>
          </Link>

          <div className={styles.uni_address_wrapper}>
            <div className={styles.uni_address}>
              <FaUniversity className={styles.uni_address_icon} />
              <span className={styles.uni_address_text}>
                {item.universityType && ucfirst(item.universityType)}
                University, Estd {item?.estd}
              </span>
            </div>
            <div className={styles.uni_address}>
              <FaMapMarkerAlt className={styles.uni_address_icon} />
              <span className={styles.uni_address_text}>
                {item?.city?.name && <>{item?.city?.name},</>}{" "}
                {item?.state?.name && <>{item?.state?.name},</>}{" "}
                {item?.country?.name && <>{item?.country?.name}</>}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* reveiws */}
      <div className={styles.uni_review_warpper}>
        {/* <div className={styles.review_icons}>
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiOutlineStar />
        </div>
        <div className={styles.review_text}>1.0(1.0)</div> */}
        <FavoriteAction
          referance="university"
          referanceId={parseInt(item.universityId)}
          is_favorite={isUniFavorite(profileInfo, item.universityId)}
        />

        <CompareAction
          referance="university"
          referanceId={parseInt(item.universityId)}
          is_compared={isUniCompare(profileInfo, item.universityId)}
        />
      </div>

      {/* Button */}
      {item && !isEmpty(item?.documentInfo) && (
        <DownloadGuide
          customStyles={{ root: { fontSize: "10px", marginBottom: "15px" } }}
          fileSrc={item?.documentInfo?.documentSrc}
          documentId={item?.documentInfo?.documentId}
          documentType="prospectus"
          universityId={parseInt(item.universityId)}
        />
      )}

      {/* Courses */}
      {item.course && item.course.length > 0 && (
        <div className={styles.courses_wrapper}>
          <ul>
            {sliceItems &&
              sliceItems.map((course, index) => (
                <li key={`co_${index}`}>
                  <Link
                    legacyBehavior
                    href={`/study/${item?.country?.slug}/university/${item?.slug}/${course?.slug}`}
                  >
                    <a target="_blank">
                      <h4 className={styles.course_name}>
                        {course?.courseName}
                      </h4>
                    </a>
                  </Link>

                  <div className={styles.course_desc}>
                    <div className={styles.course_head}>
                      <span>1st Year Total Fees</span>
                      <span>Eligibility</span>
                      <span>Duration</span>
                      <span className={styles.comp_icons}>
                        <FavoriteAction
                          referance="course"
                          referanceId={parseInt(course.courseId)}
                          is_favorite={isCourseFavorite(
                            profileInfo,
                            course.courseId
                          )}
                        />
                        <CompareAction
                          referance="course"
                          referanceId={parseInt(course.courseId)}
                          is_compared={isCourseCompare(
                            profileInfo,
                            course.courseId
                          )}
                        />
                      </span>
                    </div>
                    <div className={styles.course_body}>
                      <span>
                        {item.country && item.country.currencySymbol
                          ? item.country.currencySymbol
                          : ""}
                        {course.tuitionfees && course.tuitionfees.amountFrom
                          ? course.tuitionfees.amountFrom
                          : 0}{" "}
                        <span style={{ fontSize: "9px" }}>
                          (
                          {item.country && item.country.currency
                            ? item.country.currency
                            : ""}
                          )
                        </span>
                      </span>
                      <span>
                        <div className={`${styles.exams} relative`}>
                          {course?.exam[0]?.exam_examName} :{" "}
                          {course?.exam[0]?.course_score}{" "}
                          {MoreExam(course?.exam)}
                        </div>
                      </span>
                      <span>
                        {course.courseDuration ?? ""}{" "}
                        {ucfirst(course.courseDurationType ?? "Months")}
                      </span>
                      <span></span>
                    </div>
                  </div>
                </li>
              ))}
          </ul>

          {item.course && item.course.length > 4 && (
            <div className={styles.course_link}>
              <button
                onClick={() => {
                  goSearchResult(
                    `/study/${item?.country?.slug}/university/${item?.slug}/search-courses`,
                    item.universityId
                  );
                }}
              >
                {loader && loader.includes(item.universityId) && (
                  <CircularProgress size="10px" color="inherit" />
                )}{" "}
                View More {parseInt(item?.course?.length) - 4}{" "}
                {parseInt(item?.course?.length) > 5 ? "Courses ›" : "Course ›"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UniThumbBoxMobile;
